import Store from "@/store";

export default class BranchStoreUtils {

  static getValues() {
      return Store.getters["branch-store/getValues"];
  }

  static pushValue(values) {
      return Store.dispatch("branch-store/pushValue", values);
  }

  static removeValue(uid) {
      return Store.dispatch("branch-store/removeValue", uid);
  }
}